import { render, staticRenderFns } from "./SalaryBreakdown.vue?vue&type=template&id=78b09a1c&scoped=true"
import script from "./SalaryBreakdown.vue?vue&type=script&lang=js"
export * from "./SalaryBreakdown.vue?vue&type=script&lang=js"
import style0 from "./SalaryBreakdown.vue?vue&type=style&index=0&id=78b09a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b09a1c",
  null
  
)

export default component.exports